// extracted by mini-css-extract-plugin
export default {"display":"MainMenu_display__9pyPY","hide":"MainMenu_hide__DiCCi"};